import { render, staticRenderFns } from "./mtcLangInput.vue?vue&type=template&id=4bd44c92&scoped=true&"
import script from "./mtcLangInput.vue?vue&type=script&lang=js&"
export * from "./mtcLangInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd44c92",
  null
  
)

export default component.exports